import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { GamificationMainService } from './gamification-main.service';

@Injectable({
  providedIn: 'root'
})
export class MarketplaceService {

  data: any = {
    ordersLoaded: false,
    orders: [],
    allfilteredOrders: [],
    ordersByStatus: {
      processing: [],
    },
    ordersByRange: {
      today: [],
      week: [],
      month: [],
    },

    products: [],
    productsLowStock: [],
    productsOutOfStock: []
  }

  customRewards: any;

  constructor(
    private cvApiService: CVApiService,
    private cvConfigurationService: CvConfigurationService,
    private gamificationMainService: GamificationMainService
  ) {}

  async loadProducts(gameRewards: boolean | null) {
    try {
      let url = "/api/v1/marketplace/products?gameRewards=" + gameRewards;

      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        if(gameRewards){
            this.customRewards = response.data
            return;
        }

        this.data.products = response.data;
        this.data.productsLowStock = [];
        this.data.productsOutOfStock = [];

        if(this.data.products?.length){
          this.data.products = this.data.products.map(products => {
            //get quantity from variations
            const totalQty = products.VariationsData?.filter(variationProd => variationProd.Active &&  variationProd.VariationQuantity !== null)
                            .reduce((sum, variation) => sum + variation.VariationQuantity, null);
            //add new property to original array  
            return {
              ...products,//copy all properties to new array
              TotalQty: products.HasProductVariations ? totalQty : products.Quantity
            }
          })
        }

        this.data.products.forEach((product) => {
          if (product.TotalQty == null) {
            // no stock data
            return;
          } else if (product.TotalQty > 0 && product.TotalQty <= 3) {
            this.data.productsLowStock.push(product);
          } else if (product.TotalQty <= 0) {
            this.data.productsOutOfStock.push(product);
          }
        });

        
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading products: " + error.message);
    }
  }

  async loadProductsOrderedForOrders(orders) {
    let tmpOrders = "";

    let ordersWithoutProducts = orders.filter((order) => {
      return order.Product == null;
    });

    if (ordersWithoutProducts.length <= 0) {
      let promise = new Promise((resolve, reject) => {
        resolve('');
      });
      
      return promise;
    }

    let orderStr = ordersWithoutProducts.map((order) => {
      return order.PointStoreOrderID;
    }).join(',');

    //Getting products by batches of 20 to avoid a long url on API call
    for (let i = 0; i < orderStr.length; i += 20){
      tmpOrders =  orderStr.slice(i, (i+20));

      //If the strings ends with "," the last character is removed
      if(tmpOrders.slice(-1) == ","){
        tmpOrders = tmpOrders.slice(0, -1);
      }

      try {
        const url = "/api/v2/marketplace/orders/" + tmpOrders + "/products";
        let response = await this.cvApiService.get(url);
        if (response.status_code == 200) {
          ordersWithoutProducts.forEach((order) => {
            if (response.data[order.PointStoreOrderID]) {
              order.ProductsCollection = response.data[order.PointStoreOrderID].filter((p) => {
                return p._PointStoreProductOrderedDTO;
              });
            }
          });
        } else {
          throw response;
        }
      } catch (error) {
        showErrorMessage("Error loading products for orders: " + error.message);
      }
    }
  }

  async loadMarketplaceOrders() {
    try {
      const url = "/api/v1/marketplace/orders";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.orders = response.data;
        this.filterMarketplaceOrders();
        this.data.ordersLoaded = true;
      }
    } catch (error) {
      showErrorMessage("Error loading marketplace orders: " + error.message);
    }
  }

  filterMarketplaceOrders() {
    // filter group selector and date ranges
    var today = Date.today();
    var nextWeekStart = Date.today().addDays((7 - today.getDay()) % 7 + this.cvConfigurationService.weekStart);
    var thisWeekStart = (new Date(nextWeekStart.valueOf())).addDays(-7);
    var thisMonthStart = new Date(Date.today().setDate(1));
    var thisMonthEnd = (new Date(thisMonthStart.valueOf())).addMonths(1).addDays(-1);

    this.data.allfilteredOrders = [];
    this.data.ordersByStatus.processing = [];
    this.data.ordersByRange.today = [];
    this.data.ordersByRange.week = [];
    this.data.ordersByRange.month = [];
    this.data.orders.forEach((order) => {
      // GROUP SELECTOR
      if (!this.gamificationMainService.data.selectedLoginsHash[order.LoginID]) {
        // not in selection
        return;
      }

      this.data.allfilteredOrders.push(order);

      // STATUS
      switch (order.OrderStatus) {
        case 1: // processing
          this.data.ordersByStatus.processing.push(order);
          break;
      }

      // DATES
      // check today
      var dayOrdered = new Date(order.DateOrdered).clearTime();
      if (dayOrdered.equals(today)) {
        this.data.ordersByRange.today.push(order);

        // because today matches, this week and this month will match
        this.data.ordersByRange.week.push(order);
        this.data.ordersByRange.month.push(order);
        return;
      }

      // check this week
      if (thisWeekStart <= dayOrdered && dayOrdered < nextWeekStart) {
        this.data.ordersByRange.week.push(order);
      }

      // check this month
      if (thisMonthStart <= dayOrdered && dayOrdered <= thisMonthEnd) {
        this.data.ordersByRange.month.push(order);
      }
    });
  }
}